import { App } from "vue";
import { type LabelService, useLabelService } from "@/composables/label-service";

export const labelServiceSymbol = Symbol( 'label-service' );

/**
 * Usage (from component):
 *      ...
 *      const labelService = inject< LabelService >( labelServiceSymbol ) as LabelService;
 *      ...
 *      <div>
 *          ...
 *          <span>{{ labelService.label( 'lblXXX' ) }}</span>
 *          ...
 *     </div>
 */
const LabelServicePlugin = {
    install( app: App< Element > ) {
        // Register the Category Filter provider
        app.provide< LabelService >( labelServiceSymbol, useLabelService() );
    }
}

export default LabelServicePlugin;